import React, { useContext, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { DarkModeContext } from "../../context/DarkModeContext";
import Swal from "sweetalert2";
import logo from "../../assets/img/logo.png";
import { getToken } from "../../utils/auth";


const DOC_TYPES = [
    "AFIP",
    "FACTURANTE",
    "IIBB",
    "CONTRATO",
    "CUIT",
    "CREDENCIAL",
    "CONSTANCIA_CBU",
    "OTRO",
];

const ModalSolicitudNuevoLegajo = (props) => {
    const { show, onHide } = props;
    const { darkMode } = useContext(DarkModeContext);
    const { control, handleSubmit, formState: { errors }, reset } = useForm();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [filtroBuscador, setFiltroBuscador] = useState("");
    const [razonSocial, setRazonSocial] = useState("");
    const [usuarioId, setUsuarioId] = useState(null);

    // NUEVO: para documentos tras crear
    const [nuevoLegajoId, setNuevoLegajoId] = useState(null);
    const [docType, setDocType] = useState(DOC_TYPES[0]);
    const [docFile, setDocFile] = useState(null);
    const [docList, setDocList] = useState([]);

    const token = getToken() || "";

    const buscarUsuarioPorCuit = async () => {
        const token = getToken();
        if (!token) {
            showAlert("Error", "Token no disponible", "error");
            return;
        }
        try {
            const response = await fetch(process.env.REACT_APP_API_USUARIOS_BUSCAR, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: token, Usuario: filtroBuscador }),
            });
            if (response.ok) {
                const usuario = await response.json();
                setRazonSocial(usuario.nombre || "");
                setUsuarioId(usuario.id);
            } else {
                setRazonSocial("");
                setUsuarioId(null);
                showAlert("Error", "Usuario no encontrado o token inválido", "error");
            }
        } catch (error) {
            console.error("Error al buscar el usuario:", error);
            setRazonSocial("");
            setUsuarioId(null);
            showAlert("Error", "Hubo un problema al buscar el usuario", "error");
        }
    };

    const customOnSubmit = async (data) => {
        setIsSubmitting(true);
        const token = getToken();
        if (!token) {
            showAlert("Error", "Token no disponible", "error");
            setIsSubmitting(false);
            return;
        }

        const formData = {
            token,
            NroLegajo: data.NroLegajo,
            Terminal: data.Terminal,
            NombreDeFantasia: data.NombreDeFantasia,
            Provincia: data.Provincia,
            TipoPersona: data.TipoPersona,
            CuitTitularOSociedad: data.CuitTitularOSociedad,
            RazonSocial: data.RazonSocial,
            Calle: data.Calle,
            Numero: data.Numero,
            PisoDepto: data.PisoDepto,
            Localidad: data.Localidad,
            CodigoPostal: data.CodigoPostal,
            EmailContacto: data.EmailContacto,
            CelularWhatsapp: data.CelularWhatsapp,
            FechaDeCarga: data.FechaDeCarga,
            Asesor: data.Asesor,
            Iduser: usuarioId,
            usuario: razonSocial,
            cuit: filtroBuscador,
        };

        try {
            const response = await fetch(process.env.REACT_APP_API_LEGAJO_CREAR, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                // Espera { idLegajo: number }
                let idLegajo = null;
                try {
                    const payload = await response.json();
                    idLegajo = payload?.idLegajo ?? null;
                } catch { }

                showAlert("Éxito", "El legajo ha sido creado correctamente", "success");

                if (idLegajo) {
                    setNuevoLegajoId(idLegajo);
                    // cargar lista (vacía inicialmente)
                    listarDocs(idLegajo);
                } else {
                    // si tu endpoint todavía no devuelve idLegajo, cerramos y listo
                    onHide();
                    window.location.reload();
                }
            } else if (response.status === 409) {
                const errorData = await response.json();
                showAlert(
                    "Error",
                    errorData.message || "El número de legajo ya existe",
                    "error"
                );
            } else {
                showAlert("Error", "Hubo un problema al crear el legajo", "error");
            }
        } catch (error) {
            console.error("Error al enviar el formulario:", error);
            showAlert("Error", "Hubo un problema al enviar los datos", "error");
        }

        setIsSubmitting(false);
        reset();
        // No cierro el modal si hay idLegajo, así suben documentos
        // onHide();
    };

    function showAlert(title, text, icon) {
        Swal.fire({
            title,
            text,
            imageUrl: logo,
            imageWidth: 100,
            imageHeight: 30,
            imageAlt: "Logo",
            confirmButtonText: "Ok",
            timer: 5000,
            allowOutsideClick: true,
            customClass: {
                container: darkMode ? "swal2-container--dark" : "swal2-container--light",
                confirmButton: "my-swal-button",
            },
        });
    }

    const provincias = [
        { id: 1, nombre: "BUENOS AIRES" },
        { id: 2, nombre: "CATAMARCA" },
        { id: 3, nombre: "CHACO" },
        { id: 4, nombre: "CHUBUT" },
        { id: 5, nombre: "CÓRDOBA" },
        { id: 6, nombre: "CORRIENTES" },
        { id: 7, nombre: "ENTRE RÍOS" },
        { id: 8, nombre: "FORMOSA" },
        { id: 9, nombre: "JUJUY" },
        { id: 10, nombre: "LA PAMPA" },
        { id: 11, nombre: "LA RIOJA" },
        { id: 12, nombre: "MENDOZA" },
        { id: 13, nombre: "MISIONES" },
        { id: 14, nombre: "NEUQUÉN" },
        { id: 15, nombre: "RÍO NEGRO" },
        { id: 16, nombre: "SALTA" },
        { id: 17, nombre: "SAN JUAN" },
        { id: 18, nombre: "SAN LUIS" },
        { id: 19, nombre: "SANTA CRUZ" },
        { id: 20, nombre: "SANTA FE" },
        { id: 21, nombre: "SANTIAGO DEL ESTERO" },
        { id: 22, nombre: "TIERRA DEL FUEGO" },
        { id: 23, nombre: "TUCUMÁN" },
    ];

    const opcionesProvincias = provincias.map((provincia) => ({
        value: provincia.nombre,
        label: provincia.nombre,
    }));

    // ------- Documentos (solo si ya hay idLegajo nuevo) -------
    const listarDocs = async (idLegajo) => {
        try {
            const res = await fetch(process.env.REACT_APP_API_DOCLEGAJO_LISTAR, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: token, IdLegajo: idLegajo }),
            });
            if (!res.ok) throw new Error("No se pudo listar documentos");
            const data = await res.json();
            setDocList(data);
        } catch (e) {
            console.error(e);
            setDocList([]);
        }
    };

    const toBase64 = (file) =>
        new Promise((resolve, reject) => {
            const r = new FileReader();
            r.onload = () => resolve(r.result);
            r.onerror = reject;
            r.readAsDataURL(file);
        });

    const uploadDocumento = async () => {
        if (!docFile) {
            showAlert("Atención", "Seleccioná un archivo.", "warning");
            return;
        }
        try {
            const base64 = await toBase64(docFile);
            const res = await fetch(process.env.REACT_APP_API_DOCLEGAJO_CREAR, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Token: token,
                    IdLegajo: nuevoLegajoId,
                    NombreDocumento: docType,
                    ArchivoBase64: base64,
                }),
            });
            if (!res.ok) throw new Error("No se pudo subir el documento");
            await listarDocs(nuevoLegajoId);
            setDocFile(null);
            (document.getElementById("doc-newlegajo-input") || {}).value = null;
            showAlert("OK", "Documento subido correctamente.", "success");
        } catch (e) {
            console.error(e);
            showAlert("Error", "No se pudo subir el documento.", "error");
        }
    };

    const descargarDocumento = async (idDocumento, nombre) => {
        try {
            const res = await fetch(process.env.REACT_APP_API_DOCLEGAJO_OBTENER, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: token, IdDocumento: idDocumento }),
            });
            if (!res.ok) throw new Error("No se pudo descargar");
            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = nombre || "documento";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            console.error(e);
            showAlert("Error", "No se pudo descargar el documento.", "error");
        }
    };

    const eliminarDocumento = async (idDocumento) => {
        try {
            const res = await fetch(process.env.REACT_APP_API_DOCLEGAJO_ELIMINAR, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Token: token, IdDocumento: idDocumento }),
            });
            if (!res.ok) throw new Error("No se pudo eliminar");
            await listarDocs(nuevoLegajoId);
            showAlert("OK", "Documento eliminado.", "success");
        } catch (e) {
            console.error(e);
            showAlert("Error", "No se pudo eliminar el documento.", "error");
        }
    };

    return (
        <Modal
            {...props}
            show={show}
            onHide={onHide}
            centered
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >
            <Modal.Body className={darkMode ? "modal-content text-black" : "modal-content text-black"}>
                <section className="d-flex justify-content-between my-4">
                    <div className="ocultar-div"></div>
                    <div className="d-flex justify-content-center">
                        <h6 className="fs-18 lato-bold">Legajo</h6>
                    </div>
                    <div>
                        <button className="border-0 btn-filtro-cruz" onClick={onHide}>
                            <FontAwesomeIcon className="fs-18 " icon={faXmark} />
                        </button>
                    </div>
                </section>

                {/* --- FORMULARIO ORIGINAL (SIN CAMBIOS EN CAMPOS) --- */}
                <div className="">
                    <form onSubmit={handleSubmit(customOnSubmit)}>
                        <div className="form-group col-12">
                            <label className="fs-14 mb-2 ms-1">CUIT</label>
                            <Controller
                                name="Cuit"
                                control={control}
                                render={({ field }) => (
                                    <div className="d-flex">
                                        <input
                                            {...field}
                                            type="text"
                                            className="form-control input-cargar-nueva-busqueda me-2"
                                            maxLength="11"
                                            placeholder="Ingrese CUIT"
                                            value={filtroBuscador}
                                            onChange={(e) => setFiltroBuscador(e.target.value)}
                                        />
                                        <button type="button" className="btn btn-primary" onClick={buscarUsuarioPorCuit}>
                                            Buscar
                                        </button>
                                    </div>
                                )}
                            />
                        </div>

                        <div className="form-group col-12">
                            <label className="fs-14 mb-2 ms-1">Usuario asociado</label>
                            <Controller
                                name="UsuarioAsociado"
                                control={control}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        type="text"
                                        className="form-control input-cargar-nueva-busqueda"
                                        placeholder="Usuario asociado"
                                        value={razonSocial}
                                        readOnly
                                    />
                                )}
                            />
                        </div>

                        <div className="form-group col-12">
                            <label className="fs-14 mb-2 ms-1">N° de Terminal</label>
                            <Controller
                                name="Terminal"
                                control={control}
                                rules={{ maxLength: 10, pattern: /^[0-9]*$/ }}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        type="text"
                                        maxLength="8"
                                        className="form-control input-cargar-nueva-busqueda"
                                        placeholder="2222222222"
                                    />
                                )}
                            />
                            {errors.Terminal && (
                                <span className="fs-12 text-danger ms-1">Este campo es requerido</span>
                            )}
                        </div>

                        <div className="form-group col-12">
                            <label className="fs-14 mb-2 ms-1">N° de Legajo</label>
                            <Controller
                                name="NroLegajo"
                                control={control}
                                rules={{ maxLength: 10, pattern: /^[0-9]*$/ }}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        type="number"
                                        maxLength="10"
                                        className="form-control input-cargar-nueva-busqueda"
                                        placeholder="2222222"
                                    />
                                )}
                            />
                            {errors.NroLegajo && (
                                <span className="fs-12 text-danger ms-1">Este campo es requerido</span>
                            )}
                        </div>

                        <article className="row py-2">
                            <div className="form-group col-12">
                                <label className="fs-14 mb-2 ms-1">Nombre de fantasía</label>
                                <Controller
                                    name="NombreDeFantasia"
                                    control={control}
                                    rules={{ required: false }}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            className="form-control input-cargar-nueva-busqueda"
                                            placeholder="Cordelia"
                                        />
                                    )}
                                />
                                {errors.NombreDeFantasia && (
                                    <span className="fs-12 text-danger ms-1">Este campo es requerido</span>
                                )}
                            </div>
                            <div className="form-group col-12">
                                <label className="fs-14 mb-2 ms-1">Razón social</label>
                                <Controller
                                    name="RazonSocial"
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            className="form-control input-cargar-nueva-busqueda"
                                            placeholder="Razón social"
                                        />
                                    )}
                                />
                            </div>
                            <div className="form-group col-12">
                                <label className="fs-14 mb-2 ms-1">Tipo de persona</label>
                                <Controller
                                    name="TipoPersona"
                                    control={control}
                                    render={({ field }) => (
                                        <select
                                            {...field}
                                            className="form-select input-cargar-nueva-busqueda"
                                        >
                                            <option value="">Seleccionar</option>
                                            <option value="Persona Física">Persona Física</option>
                                            <option value="Persona Jurídica">Persona Jurídica</option>
                                        </select>
                                    )}
                                />
                            </div>
                            <div className="form-group col-12">
                                <label className="fs-14 mb-2 ms-1">CUIT titular / sociedad</label>
                                <Controller
                                    name="CuitTitularOSociedad"
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            maxLength="20"
                                            className="form-control input-cargar-nueva-busqueda"
                                            placeholder="20-XXXXXXXX-X"
                                        />
                                    )}
                                />
                            </div>
                            <div className="form-group col-md-6">
                                <label className="fs-14 mb-2 ms-1">Calle</label>
                                <Controller
                                    name="Calle"
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            className="form-control input-cargar-nueva-busqueda"
                                            placeholder="Calle"
                                        />
                                    )}
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <label className="fs-14 mb-2 ms-1">Número</label>
                                <Controller
                                    name="Numero"
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            className="form-control input-cargar-nueva-busqueda"
                                            placeholder="Número"
                                        />
                                    )}
                                />
                            </div>
                            <div className="form-group col-md-3">
                                <label className="fs-14 mb-2 ms-1">Piso / Depto</label>
                                <Controller
                                    name="PisoDepto"
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            className="form-control input-cargar-nueva-busqueda"
                                            placeholder="Piso / Depto"
                                        />
                                    )}
                                />
                            </div>
                            <div className="form-group col-md-6">
                                <label className="fs-14 mb-2 ms-1">Localidad</label>
                                <Controller
                                    name="Localidad"
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            className="form-control input-cargar-nueva-busqueda"
                                            placeholder="Localidad"
                                        />
                                    )}
                                />
                            </div>
                            <div className="form-group col-12">
                                <label className="fs-14 mb-2 ms-1">Provincia</label>
                                <Controller
                                    name="Provincia"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={opcionesProvincias}
                                            className="select-control-custom lato-bold border-0"
                                            classNamePrefix="select"
                                            placeholder="Provincias"
                                            onChange={(selectedOption) => field.onChange(selectedOption.value)}
                                            value={opcionesProvincias.find((option) => option.value === field.value)}
                                        />
                                    )}
                                />
                                {errors.Provincia && (
                                    <span className="fs-12 text-danger ms-1">Este campo es requerido</span>
                                )}
                            </div>
                            <div className="form-group col-md-6">
                                <label className="fs-14 mb-2 ms-1">Código postal</label>
                                <Controller
                                    name="CodigoPostal"
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            className="form-control input-cargar-nueva-busqueda"
                                            placeholder="Código postal"
                                        />
                                    )}
                                />
                            </div>
                            <div className="form-group col-md-6">
                                <label className="fs-14 mb-2 ms-1">Email de contacto</label>
                                <Controller
                                    name="EmailContacto"
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="email"
                                            className="form-control input-cargar-nueva-busqueda"
                                            placeholder="email@zoco.com"
                                        />
                                    )}
                                />
                            </div>
                            <div className="form-group col-md-6">
                                <label className="fs-14 mb-2 ms-1">Celular / WhatsApp</label>
                                <Controller
                                    name="CelularWhatsapp"
                                    control={control}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            className="form-control input-cargar-nueva-busqueda"
                                            placeholder="+54 11 1234-5678"
                                        />
                                    )}
                                />
                            </div>
                        </article>

                        <article className="row py-2">
                            <div className="form-group col-12">
                                <label className="fs-14 mb-2 ms-1">Asesor-Gestor</label>
                                <Controller
                                    name="Asesor"
                                    control={control}
                                    rules={{ required: false }}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            className="form-control input-cargar-nueva-busqueda"
                                            placeholder="Asesor - Gestor"
                                        />
                                    )}
                                />
                                {errors.Asesor && (
                                    <span className="fs-12 text-danger ms-1">Este campo es requerido</span>
                                )}
                            </div>
                        </article>

                        <div className="d-flex justify-content-between mt-5">
                            <button
                                className={
                                    darkMode
                                        ? "btn-cancel-modificaciones-nuevo-puesto border-0 lato-bold text-white"
                                        : "btn-cancel-modificaciones-nuevo-puesto border-0 lato-bold text-white"
                                }
                                onClick={onHide}
                                type="button"
                            >
                                Cancelar
                            </button>
                            <button
                                className={
                                    darkMode
                                        ? "btn-guardar-modificaciones-nuevo-puesto border-0 lato-bold text-white"
                                        : "btn-guardar-modificaciones-nuevo-puesto border-0 lato-bold text-white"
                                }
                                disabled={isSubmitting}
                                type="submit"
                            >
                                {isSubmitting ? <Spinner animation="border" size="sm" /> : "Guardar"}
                            </button>
                        </div>
                    </form>
                </div>

                {/* ------ BLOQUE DE DOCUMENTOS (solo si ya tengo id del legajo creado) ------ */}
                {nuevoLegajoId && (
                    <>
                        <hr />
                        <h6 className="fs-16 lato-bold mb-2">Documentos del Legajo (#{nuevoLegajoId})</h6>

                        <div className="row g-2 align-items-end">
                            <div className="col-md-4">
                                <label className="fs-14 mb-1">Tipo de documento</label>
                                <select
                                    className="form-select"
                                    value={docType}
                                    onChange={(e) => setDocType(e.target.value)}
                                >
                                    {DOC_TYPES.map((t) => (
                                        <option key={t} value={t}>{t}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label className="fs-14 mb-1">Archivo (se sube de a 1)</label>
                                <input
                                    id="doc-newlegajo-input"
                                    type="file"
                                    className="form-control"
                                    onChange={(e) => setDocFile(e.target.files?.[0] || null)}
                                />
                            </div>
                            <div className="col-md-2">
                                <button className="btn btn-primary w-100" onClick={uploadDocumento}>
                                    Subir
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive mt-3">
                            <table className="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Tipo/Nombre</th>
                                        <th>Tamaño</th>
                                        <th className="text-end">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {docList.length === 0 ? (
                                        <tr>
                                            <td colSpan={4} className="text-center">Sin documentos</td>
                                        </tr>
                                    ) : (
                                        docList.map((d) => (
                                            <tr key={d.Id}>
                                                <td>{d.Id}</td>
                                                <td>{d.NombreDocumento}</td>
                                                <td>{d.Bytes} bytes</td>
                                                <td className="text-end">
                                                    <button
                                                        className="btn btn-sm btn-outline-primary me-2"
                                                        onClick={() => descargarDocumento(d.Id, d.NombreDocumento)}
                                                    >
                                                        Descargar
                                                    </button>
                                                    <button
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => eliminarDocumento(d.Id)}
                                                    >
                                                        Eliminar
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ModalSolicitudNuevoLegajo;
